import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import Icon from 'components/Icon';
import { colors } from 'style/config';

/** Renders a green checkmark badge with "In Stock" label for a fulfillment slot in the Pickup & Delivery zone. */
const InStock = ({ getText }) => (
    <Text
        lineHeight={'none'}
        fontSize='sm'
        fontWeight='bold'
        color={colors.green}
    >
        <Icon
            name='checkmark'
            size={16}
            marginRight={2}
        />
        {getText('inStock')}
    </Text>
);

InStock.propTypes = { getText: PropTypes.func.isRequired };

export default wrapFunctionalComponent(InStock, 'InStock');
